import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useEffect, useRef, useState } from 'react';
import cn from 'classnames';
import { DropdownMenu, IconButton, Typography, useStateInRef } from 'seagull';
import { TrashLine, Edit2Liner18, MoreVertical, CopyLiner24 } from 'seagull/icons';
import { DefaultValuePopover } from '../../TemplateVariables/DefaultValuePopover/DefaultValuePopover';
import { useTextFieldVariableIntegration } from '../../TemplateVariables/hooks/useTextFieldVariableIntegration';
import { VariableInlineRenderer } from '../../TemplateVariables/VariableInlineRenderer/VariableInlineRenderer';
import { VariablePickerPopover } from '../../TemplateVariables/VariablePickerPopover/VariablePickerPopover';
import styles from './ServicePackages.module.scss';
const tabPanelId = 'services-in-pkg';
export default function ServicePackagesTab(props) {
    const { bundle, isSelected, testId, bundlesCount, isReadonly, onClick, onRemove, onChangeName, onDuplicate: handleDuplicate } = props;
    const getProps = useStateInRef(props);
    const [isEditingName, setIsEditingName] = useState(false);
    const [editedName, setEditedName] = useState(bundle.name);
    const inputRef = useRef(null);
    const { enabled, inputProps, pickerPopoverProps, defaultValuePopoverProps } = useTextFieldVariableIntegration(inputRef, setEditedName);
    useEffect(()=>{
        if (isEditingName) {
            const cancelEditOnEscapeKey = (e)=>{
                if (e.key === 'Escape') {
                    setEditedName(getProps().bundle.name);
                    setIsEditingName(false);
                }
            };
            window.addEventListener('keydown', cancelEditOnEscapeKey);
            return ()=>window.removeEventListener('keydown', cancelEditOnEscapeKey);
        }
    }, [
        isEditingName
    ]);
    const applyEdit = ()=>{
        onChangeName(editedName.trim(), bundle.id);
        setIsEditingName(false);
    };
    const onRename = ()=>{
        onClick(bundle.id);
        setIsEditingName(true);
        setTimeout(()=>inputRef.current.focus());
    };
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsxs("button", {
                role: "tab",
                className: cn(styles.tab, {
                    [styles.editing]: isEditingName
                }),
                "aria-selected": isSelected ? 'true' : 'false',
                "aria-controls": tabPanelId,
                "data-testid": testId,
                onClick: ()=>onClick(bundle.id),
                onDoubleClick: onRename,
                children: [
                    isEditingName ? /*#__PURE__*/ _jsx("form", {
                        onSubmit: (e)=>{
                            e.preventDefault();
                            applyEdit();
                        },
                        className: styles.form,
                        children: /*#__PURE__*/ _jsx(Typography, {
                            as: "input",
                            ref: inputRef,
                            className: styles.nameInput,
                            testId: "".concat(testId, "-input"),
                            value: editedName,
                            onChange: (e)=>setEditedName(e.target.value),
                            onBlur: ()=>{
                                if (!pickerPopoverProps.anchorEl) applyEdit();
                            },
                            onKeyDown: inputProps === null || inputProps === void 0 ? void 0 : inputProps.onKeyDown
                        })
                    }) : /*#__PURE__*/ _jsx(Typography, {
                        ellipsis: true,
                        children: /*#__PURE__*/ _jsx(VariableInlineRenderer, {
                            text: bundle.name,
                            mode: "text"
                        })
                    }),
                    !isEditingName && !isReadonly && /*#__PURE__*/ _jsxs(DropdownMenu, {
                        onClose: (anchorEl, reason, event)=>event.stopPropagation(),
                        target: /*#__PURE__*/ _jsx(IconButton, {
                            noPadding: true,
                            skin: "transparent",
                            size: "small",
                            testId: "".concat(testId, "-dropdown"),
                            onClick: (e)=>e.stopPropagation(),
                            children: /*#__PURE__*/ _jsx(MoreVertical, {})
                        }),
                        children: [
                            /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                                iconStart: /*#__PURE__*/ _jsx("div", {
                                    className: styles.iconContainer,
                                    children: /*#__PURE__*/ _jsx(Edit2Liner18, {})
                                }),
                                testId: "".concat(testId, "-edit"),
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    onRename();
                                },
                                children: "Rename"
                            }),
                            bundlesCount < 3 && /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                                iconStart: /*#__PURE__*/ _jsx(CopyLiner24, {}),
                                testId: "".concat(testId, "-duplicate"),
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    handleDuplicate(bundle);
                                },
                                children: "Duplicate"
                            }),
                            /*#__PURE__*/ _jsx(DropdownMenu.Item, {
                                skin: "error",
                                testId: "".concat(testId, "-remove"),
                                iconStart: /*#__PURE__*/ _jsx("div", {
                                    className: styles.iconContainer,
                                    children: /*#__PURE__*/ _jsx(TrashLine, {})
                                }),
                                onClick: (e)=>{
                                    e.stopPropagation();
                                    onClick(bundle.id);
                                    onRemove(bundle.id);
                                },
                                children: "Remove"
                            })
                        ]
                    })
                ]
            }, bundle.id),
            enabled && /*#__PURE__*/ _jsx(VariablePickerPopover, _object_spread({}, pickerPopoverProps)),
            enabled && /*#__PURE__*/ _jsx(DefaultValuePopover, _object_spread({}, defaultValuePopoverProps))
        ]
    });
}
